

import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const HomeExclude = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" fill="none" viewBox="0 0 28 28">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1646_14447)">
        <path d="M25.0271 10.9164V10.9163C25.0272 10.5504 24.9369 10.1902 24.7643 9.86753C24.5917 9.54494 24.3421 9.26994 24.0378 9.06694L25.0271 10.9164ZM25.0271 10.9164V22.8052V22.8053C25.0272 23.0972 24.9698 23.3861 24.8581 23.6558C24.7465 23.9254 24.5828 24.1704 24.3765 24.3768C24.1702 24.5832 23.9252 24.7469 23.6556 24.8586C23.386 24.9702 23.097 25.0277 22.8052 25.0277H22.805L17.75 25.0287M25.0271 10.9164L17.75 25.0287M17.75 25.0287V15.3482V14.5982H17H11H10.25V15.3482V25.0287L4.97207 25.0277H4.97202C4.38264 25.0277 3.81743 24.7935 3.40072 24.3767C2.98401 23.9599 2.74994 23.3946 2.75 22.8052V22.8052V10.9165C2.75 10.9165 2.75 10.9164 2.75 10.9164C2.75005 10.5505 2.84039 10.1903 3.013 9.86761C3.18557 9.54505 3.43505 9.27004 3.73931 9.06696C3.7394 9.0669 3.73948 9.06685 3.73956 9.06679C3.73957 9.06679 3.73958 9.06678 3.7396 9.06677L12.6562 3.12311L17.75 25.0287ZM15.1215 3.12311L24.0377 9.06687L12.6563 3.12307C13.0213 2.87981 13.4502 2.75 13.8889 2.75C14.3275 2.75 14.7564 2.8798 15.1214 3.12306C15.1215 3.12308 15.1215 3.12309 15.1215 3.12311Z" stroke="#2E434D" strokeWidth="1.5"/>
        </g>
        <defs>
        <clipPath id="clip0_1646_14447">
        <rect width="28" height="28" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export default HomeExclude;